import React from "react";

export interface RevenueThisMonthInsightItem {
  title: string;
  description: string;
  accentColor?: "success" | "neutral";
}

export interface RevenueThisMonthInsightsPanelProps {
  monthLabel?: string;
  insights: RevenueThisMonthInsightItem[];
  loading?: boolean;
}

const barClass: Record<NonNullable<RevenueThisMonthInsightItem["accentColor"]>, string> = {
  success: "bg-success-500",
  neutral: "bg-neutral-300",
};

export function RevenueThisMonthInsightsPanel({
  monthLabel = "Insights",
  insights,
  loading = false,
}: RevenueThisMonthInsightsPanelProps) {
  if (loading) {
    return (
      <div className="flex flex-col items-start gap-4 flex-1 min-w-0">
        <div className="h-4 w-28 animate-pulse rounded bg-neutral-200" />
        {[1, 2].map((i) => (
          <div
            key={i}
            className="flex w-full gap-4 rounded-lg border border-solid border-neutral-100 bg-neutral-50 px-4 py-4 min-h-[60px] animate-pulse"
          />
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-col items-start gap-4 flex-1 min-w-0">
      <span className="text-caption-bold font-caption-bold text-neutral-400 uppercase tracking-widest">
        {monthLabel}
      </span>
      {insights.map((item, i) => (
        <div
          key={i}
          className="flex w-full gap-4 rounded-lg border border-solid border-neutral-100 bg-neutral-50 px-4 py-4 items-stretch"
        >
          <div
            className={`flex w-1 flex-none flex-col items-start rounded-full ${barClass[item.accentColor ?? "neutral"]}`}
          />
          <div className="flex flex-col items-start gap-1 flex-1">
            <span className="text-caption-bold font-caption-bold text-neutral-400 uppercase tracking-wider">
              {item.title}
            </span>
            <span className="text-body font-body text-neutral-700">
              {item.description}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
